import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

class ModuleSubscriptionStore extends ReduceStore {

    getInitialState() {
        return {
            subscriptions: [],
            isFetching: 0,
            fetchedAll: false,
        };
    }

    getSubscription(moduleId, userId) {
        return this.getState().subscriptions.find((sub) => (sub.moduleId === moduleId && sub.userId === userId));
    }

    getModuleSubscriptions(moduleId) {
        return this.getState().subscriptions.filter((sub) => (sub.moduleId === moduleId && sub.status !== 'none' && sub.status !== 'deleted'));
    }

    getByModuleEvent(moduleId, eventId) {
        return this.getState().subscriptions.filter((sub) => (sub.moduleId === moduleId && sub.eventId === eventId && sub.status !== 'none' && sub.status !== 'deleted'));
    }

    getUserSubscriptions(userId) {
        return this.getState().subscriptions.filter((sub) => (sub.userId === userId && sub.status !== 'deleted'));
    }

    getIndex(moduleId, userId) {
        return this._state.subscriptions.findIndex((sub) => (!!sub && sub.moduleId === moduleId && sub.userId === userId));
    }

    isFetching() {
        return this.getState().isFetching > 0;
    }

    fetchedAll() {
        return this.getState().fetchedAll;
    }

    reduce(state, action) {

        let data, index;
        switch (action.type) {
            case ActionTypes.MODULE_SUBSCRIPTION_LIST_REQUEST:
                return update(state, { isFetching: { $set: state.isFetching + 1 }});

            case ActionTypes.MODULE_SUBSCRIPTION_LIST_SUCCESS:
                return !!action.payload.clearAll ? { ...state, isFetching: false, subscriptions: action.data } : this.updateBulk(action.data);

            case ActionTypes.MODULE_SUBSCRIPTION_LIST_FAILURE:
                return {...state, isFetching: state.isFetching - 1};

            case ActionTypes.MODULE_SUBSCRIPTION_INFO_REQUEST:
            case ActionTypes.MODULE_SUBSCRIPTION_SWITCH_REQUEST:
                return {...state, isFetching: state.isFetching + 1};

            case ActionTypes.MODULE_SUBSCRIPTION_INFO_SUCCESS:
            case ActionTypes.MODULE_SUBSCRIPTION_SWITCH_SUCCESS:
                return this.updateOne(action.data);

            case ActionTypes.MODULE_SUBSCRIPTION_INFO_FAILURE:
                // in this case we insert/update with new info
                data = {moduleId: action.payload.moduleId, userId: action.payload.userId, status: 'none' };
                return this.updateOne(data);

            case ActionTypes.MODULE_SUBSCRIPTION_SWITCH_FAILURE:
                return {...state, isFetching: state.isFetching - 1};

            case ActionTypes.MODULE_SUBSCRIPTION_SAVE_REQUEST:
                data = Object.assign({moduleId: action.payload.moduleId, userId: action.payload.userId, loading: true }, action.payload.parameters);
                return this.updateOne(data, +1);

            case ActionTypes.MODULE_SUBSCRIPTION_DELETE_SUCCESS:
                if (action.data) {
                    index = this.getIndex(action.payload.moduleId, action.payload.userId);
                    return update(state, { subscriptions: { $splice: [[index, 1]] }});
                }
                return state;

            case ActionTypes.MODULE_SUBSCRIPTION_SAVE_SUCCESS:
            case ActionTypes.MODULE_REGISTRATION_SAVE_SUCCESS:
                return this.updateOne(action.data);

            case ActionTypes.MODULE_SUBSCRIPTION_SAVE_FAILURE:
                data = action.payload.current || {moduleId: action.payload.moduleId, userId: action.payload.userId, status: 'none' };
                return this.updateOne(data);

            case ActionTypes.MODULE_REGISTRATION_SAVE_REQUEST:
                index = this._state.subscriptions.findIndex((sub) => (!!sub && sub.moduleId === action.payload.moduleId && sub.userId === action.payload.userId));
                return update(state, { subscriptions: { [index]: { registrationId: { $set: 'pending' }}}, isFetching: { $set: state.isFetching + 1}});

            case ActionTypes.MODULE_REGISTRATION_SAVE_FAILURE:
                index = this._state.subscriptions.findIndex((sub) => (!!sub && sub.moduleId === action.payload.moduleId && sub.userId === action.payload.userId));
                return update(state, { subscriptions: { [index]: { registrationId: { $set: 'failed' }}}, isFetching: { $set: state.isFetching - 1}});

            case ActionTypes.MODULE_EVENT_ASSIGN_REQUEST:
                return update(state, { isFetching: { $set: true }});

            case ActionTypes.MODULE_EVENT_ASSIGN_SUCCESS:
                return this.updateBulk(action.data);

            case ActionTypes.MODULE_EVENT_ASSIGN_FAILURE:
                return update(state, { isFetching: { $set: false }});

            default:
                return state;
        }
    }

    updateOne(data, fetching = -1) {
        const index = this.getSubscriptionIndex(data.moduleId, data.userId);
        const state = this.getState();

        if (0 <= index) {
            return update(state, { subscriptions: { [index]: { $set: data }}, isFetching: { $set: state.isFetching + fetching }});
        } else {
            return update(state, { subscriptions: { $push: [data] }, isFetching: { $set: state.isFetching + fetching }});
        }
    }

    updateBulk(data) {
        let updates = {};
        let push = [];
        data.forEach(subscription => {
            const index = this.getSubscriptionIndex(subscription.moduleId, subscription.userId);
            if (0 <= index) {
                updates[index] = {$set: subscription};
            } else {
                push.push(subscription);
            }
        });
        if (push.length > 0) {
            updates['$push'] = push;
        }
        return update(this.getState(), { subscriptions: updates, isFetching: { $set: this.getState().isFetching - 1 }, fetchedAll: { $set : data.length === 0}});
    }

    getSubscriptionIndex(moduleId, userId) {
        return this._state.subscriptions.findIndex((sub) => (sub.moduleId === moduleId && sub.userId === userId));
    }
}

export default new ModuleSubscriptionStore(CentricDispatcher);

